import React from 'react';
import moment from 'moment';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, NOTA_DE_CREDITO, BOLETA_DE_VENTA } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import {
    VENTA_MODIFICAR_TOTAL_PRODUCTO,
    EMPRESA_GRIFO,
    VENTA_VALIDAR_TOPE_MAXIMO_VENTAS_SOLES,
    VALIDAR_STOCK,
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    VENTA_VISUALIZACION_DOCUMENTOS,
    IMPUESTO_PROMOCION_MUNICIPAL,
    CONVERSION_MEDIDA,
    CONTROL_COMPBANTE,
    LOGISTICA_PRODUCTOS_CON_LOTE
} from '../../../common/types/parametroType'
import printFormatMock from '../../../common/mock/printFormatMock';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import comprobanteService from '../../../service/ventas/comprobanteService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import fenologicaService from '../../../service/administracion/fenologicaService';
import productoService from '../../../service/administracion/productoService';
import clienteService from '../../../service/administracion/clienteService';
import motivoNotaCreditoService from '../../../service/administracion/motivoNotaCreditoService';
import usuarioService from '../../../service/seguridad/usuarioService';
import movimientoService from "../../../service/logistica/movimientoService";
import Header from '../../../components/Header';
import Filters from '../Comprobante/Filters';
import SearchProductModal from '../../../components/SearchProductModal';
import proyectoService from '../../../service/administracion/proyectoService';

import ResultList from '../Comprobante/ResultList';
import FormModal from '../Notas/FormModal';
import EditarNombreProductoModal from '../Comprobante/EditarNombreProductoModal';
import EmitirModal from '../Comprobante/EmitirModal';
import ImprimirModal from '../Comprobante/ImprimirModal';
import AgregarSerieModal from "../Notas/AgregarSerieModal";
import CdrModal from '../Comprobante/CdrModal';
import CorreoModal from '../Comprobante/CorreoModal';
import ViewModal from '../Comprobante/ViewModal';
import ImportarModal from './ImportarModal';
import { CONTADO, CREDITO } from '../../../common/types/formaPagoType';

import notasService from '../../../service/ventas/notasService';

import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import { VENTA } from '../../../common/types/moduloType';
import { EMISION_AUTO, CREAR_COPIAR_COMPRO, EMISION_COMPRO, EDITAR_COMPRO, EDITAR_PRECIO_VENTA } from '../../../common/types/configuracionType';
import { CARNET_EXTRANJERIA, DNI, OTROS, PASAPORTE, RUC } from '../../../common/types/tipoDocumentoType';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';

export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingNew: false,
            loadingSource: true,
            saveLoading: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            formasPago: [],
            estado: [],
            proyectos: [],
            motivosNotaCredito: [],
            configuraciones: [],
            totaldocument: [],
            cultivos: [],
            company: {},
            filter: {
                idTipoComprobante: NOTA_DE_CREDITO.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                documento: '',
                idEstado: 0,
                idProyecto: 0,
                cliente: "",
                idMotivo: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: []
            },
            editarNombreProductoFormValues: {
                id: '',
                nombre: ''
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                precioUnitInclyIGV: false,
                dataSource: []
            },
            emitirVisible: false,
            emitirFilePdf: undefined,
            imprimirVisible: false,
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                isEpson: false,
                formatos: printFormatMock.values
            },
            correoVisible: false,
            isCredito: false,

            correoFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                correoCliente: '',
                formatos: printFormatMock.values
            },
            agregarSerieModal: {
                serie: '',
                idProducto: 0,
                listaDetalleSerie: [],
                selectedRowKeys: []
            },
            cdrVisible: false,
            selectedItem: {},
            viewVisible: false,
            viewFormValues: {},
            importarVisible: false,
            importarFormValues: {
                dataSource: []
            },
        }
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idMovimiento: 0,
            idTipoComprobante: NOTA_DE_CREDITO.ID,
            flagGuiaRemisionGeneraSalidas: false,
            idCliente: 0,
            idEstablecimientoCliente: 0,
            idProyecto: 0,
            idVendedor: 0,
            idAlmacen: 0,
            idFormaPago: CONTADO,
            idDocumentoImportadoCredito: 0,
            idCaja: 0,
            idMoneda: SOLES,
            idListaPrecio: 0,
            // idComprobanteEstado: 0,
            idEstablecimiento: 0,
            idDetraccion: 0,
            idUsuarioRegistro: auth.user().id,
            serie: "",
            documento: "",
            fechaStr: global.fetchCurrentDateStr(),
            fechaVencimientoStr: global.fetchCurrentDateStr(),
            diasVencimiento: 0,
            numeroPlaca: "",
            tipoCambio: 0,
            observacion: "",
            giroNegocio: "",
            flagExportacion: false,
            flagPercepcion: false,
            flagDetraccion: false,
            flagAnticipo: false,
            flagRegularizacion: false,
            totalAnticipo: 0,
            flagDocumentoEnviado: false,
            flagPago: false,
            flagGrifo: false,
            idMotivoNotaCredito: 0,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            listaComprobanteCuota: [],
            /*********************/
            sumaTotalDetalle: 0,
            sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaIsc: 0,
            sumaTotal: 0,
            porcentajeDetraccion: 0,
            importeDetraccion: 0,
            totalDetraccion: 0,
            porcentajePercepcion: 0,
            importePercepcion: 0,
            totalPercepcion: 0,
            flagTipoBusquedaScanner: 0,
            precioUnitarioDetailDisabled: false,
            totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            flagEmpresaGrifo: false,
            almacenLoading: false,
            clienteLoading: false,
            flagContingencia: false,
            flagDisableSerieDocumento: true,
            flagDisableFecha: auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false,
            otroImpuesto: 0,// auth.user().parametros.filter(m => m.abreviatura === IMPUESTO_PROMOCION_MUNICIPAL)[0].valor === "1" ? 2 : 1,
            Tipoimpuesto: lst_tipo_impuesto,

            activeKey: "1",
            documentoCliente: "",
            monedas: [],
            formasPago: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            detracciones: [],
            detalleProductos: [],
            motivosNotaCredito: [],
            proyectos: [],
            cultivos: [],
            fenologicas: [],
            flagAmazonia: false,
            flagAmazoniaServicio: false,
            flagAmazoniaBien: false,
            idCultivo: 0,
            idFenologica: 0,

            sumaExonerada: 0,
            sumaInafecta: 0,
            sumaGratuita: 0,
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: NOTA_DE_CREDITO.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            documento: '',
            idProyecto: 0,
            cliente: "",
            idMotivo: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await comprobanteService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Notas de Crédito.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await comprobanteService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Notas de Crédito.pdf");
    };

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await comprobanteService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }
    /******************** FORM MODAL *****************/

    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: NOTA_DE_CREDITO.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }

    handleNew = async () => {

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_COPIAR_COMPRO).length >= 1 ? true : false;
        var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
        var params = auth.user().parametros;

        if (!flagCrear) {
            message.warning('Usted no puede crear comprobantes.');
            return;
        }


        var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
        if (controlDcumento) {
            if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
                message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
                return;
            }
        }

        this.setState({ loadingNew: true });

        const clientes = await clienteService.listar();

        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = clientes;
        formValues.motivosNotaCredito = await motivoNotaCreditoService.listar();
        formValues.formasPago = this.state.formasPago;
        formValues.unidadesMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;
        formValues.proyectos = this.state.proyectos;
        formValues.precioUnitarioDetailDisabled = flagPrecioEditar;
        formValues.cultivos = this.state.cultivos;
        formValues.otroImpuesto = this.state.company.idTipoImpuesto;
        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        // const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const datosIniciales = await this.obtenerDatosIniciales({ idUsuario: auth.user().id, idTipoComprobante: NOTA_DE_CREDITO.ID });

        if (datosIniciales !== undefined) {
            formValues.fechaStr = datosIniciales.fechaStr;
            formValues.fechaVencimientoStr = datosIniciales.fechaStr;
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.serie = datosIniciales.serie;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);

            formValues.almacenes = almacenFilter ? almacenFilter : [];
            formValues.listasPrecio = this.state.listasPrecio.filter(
                (m) => m.idEstablecimiento === formValues.idEstablecimiento
            );
        }


        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                loadingNew: false,
                visible: true,
                formValues,
                // productos: productos ? productos : []
            });
        }
    };
    calculateDescuento = async (descuento, PorcentajeDescuento, form) => {
        if (descuento !== undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    importeDescuentoGlobal: descuento,
                    porcentajeDescuentoGlobal: PorcentajeDescuento
                }
            });

            form.setFieldsValue({
                importeDescuentoGlobal: parseFloat(descuento.toFixed(2)),
                porcentajeDescuentoGlobal: parseFloat(PorcentajeDescuento.toFixed(2)
                ),
            });
        }


    }
    handleEdit = async (item) => {

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_COMPRO).length >= 1 ? true : false;
        var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;

        if (!flagCrear) {
            message.warning('Usted no puede editar comprobantes.');
            return;
        }
        this.setState({ loadingEdit: true });
        const response = await comprobanteService.obtenerPorId(item.id);

        if (response === undefined) {
            this.setState({ loadingEdit: false });
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;

        var formValues = {
            id: response.id,
            idMovimiento: response.idMovimiento,
            flagGuiaRemisionGeneraSalidas: false,
            idTipoComprobante: response.idTipoComprobante,
            idCliente: response.idCliente,
            idEstablecimientoCliente: response.idEstablecimientoCliente,
            direccionCliente: response.direccionCliente,
            idVendedor: response.idVendedor,
            idAlmacen: response.idAlmacen,
            idFormaPago: response.idFormaPago,
            idMoneda: response.idMoneda,
            idListaPrecio: response.idListaPrecio,
            idEstablecimiento: response.idEstablecimiento,
            idDetraccion: response.idDetraccion,
            idUsuarioRegistro: auth.user().id,
            idProyecto: response.idProyecto,

            idCultivo: response.idCultivo,
            idFenologica: response.idFenologica,
            serie: response.serie,
            documento: response.documento,
            fechaStr: response.fechaStr,
            fechaVencimientoStr: response.fechaVencimientoStr,
            diasVencimiento: response.diasVencimiento,
            numeroPlaca: response.numeroPlaca,
            tipoCambio: response.tipoCambio,
            idMotivoNotaCredito: response.idMotivoNotaCredito,
            observacion: response.observacion,
            flagExportacion: response.flagExportacion,
            flagPercepcion: response.flagPercepcion,
            flagDetraccion: response.flagDetraccion,
            flagGrifo: response.flagGrifo,
            flagContingencia: response.flagContingencia,
            flagDisableSerieDocumento: response.flagContingencia ? false : true,
            flagDisableFecha: auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            listaComprobanteCuota: [],
            flagAnticipo: response.flagAnticipo,
            flagRegularizacion: response.flagRegularizacion,
            totalAnticipo: response.totalAnticipo == undefined ? 0 : response.totalAnticipo,
            flagDocumentoEnviado: item.flagDocumentoEnviado,
            otroImpuesto: response.tipoImpuesto,
            precioUnitarioDetailDisabled: flagPrecioEditar,

            /*********************/
            activeKey: "1",
            sumaTotalDetalle: response.totalDetalle,
            sumaImporteDescuento: response.importeDescuento,
            sumaSubTotal: response.subTotal,
            sumaIgv: response.igv,
            sumaIsc: response.isc,
            sumaTotal: response.total,
            porcentajeDetraccion: response.porcentajeDetraccion,
            importeDetraccion: response.importeDetraccion,
            totalDetraccion: response.totalDetraccion,
            porcentajePercepcion: response.porcentajePercepcion,
            importePercepcion: response.importePercepcion,
            totalPercepcion: response.totalPercepcion,
            totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            flagEmpresaGrifo: this.state.company.idTipoEmpresa == 1 ? true : false,

            almacenLoading: false,
            clienteLoading: false,
            detalleProductos: [],
            motivosNotaCredito: [],

            sumaExonerada: 0,
            sumaInafecta: 0,
            sumaGratuita: 0,
        }
        response.detalles.forEach(element => {
            const identifier = global.fetchUniqueCode();

            formValues.listaComprobanteDetalle.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                flagExonerado: element.flagExonerado,
                flagGratuito: element.flagGratuito,
                flagAplicarSerie: element.flagAplicarSerie,
                flagISC: element.flagISC,
                isc: element.importeISC,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                precioPromedio: element.precioPromedio,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                cantidad: element.cantidad,
                totalDetalle: element.totalDetalle,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                subTotal: element.subTotal,
                igv: element.igv,
                total: element.total,
                flagConversion: element.flagConversion,
                itemConversion: [],
                idImpuesto: element.idImpuesto,
                flagVencimiento: element.flagVencimiento,
                fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
                listaDetalleSerie: element.listaDetalleSerie,
                listaDetalleSerieAll: element.listaDetalleSerie,
                detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
            });

            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                cantidad: element.cantidad,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                precioPromedio: element.precioPromedio,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAplicarSerie: element.flagAplicarSerie,
                flagAfecto: element.flagAfecto,
                flagExonerado: element.flagExonerado,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                flagConversion: element.flagConversion,
                itemConversion: [],
                idImpuesto: element.idImpuesto,
                flagVencimiento: element.flagVencimiento,
                fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
                listaDetalleSerie: element.listaDetalleSerie,
                listaDetalleSerieAll: element.listaDetalleSerie,
                detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
            });
        });

        response.referencias.forEach(element => {
            formValues.listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                flagInterno: element.flagInterno,
                idReferenciaOrigen: element.idReferenciaOrigen,
                idReferencia: element.idReferencia,
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento
            });
        });

        response.cuotas.forEach(element => {
            formValues.listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                fechaVencimiento: element.fechaVencimientoStr,
                montoCuota: element.montoCuota
            });
        });

        //const clientes = await clienteService.listar();

        const clientes = await clienteService.getByComprobante({
            id: formValues.idCliente,
            value: '',
            type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
        });

        const clienteFiltered = clientes.filter(m => m.id === formValues.idCliente);
        const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
        const idEntidad = clienteFiltered.length > 0 ? clienteFiltered[0].idEntidad : 0;
        const direcciones = await establecimientoService.listarPorIdEntidad(idEntidad);
        const motivosNotaCredito = await motivoNotaCreditoService.listar();
        const fenologicas = response.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);

        formValues.cultivos = this.state.cultivos;
        formValues.fenologicas = fenologicas;

        formValues.formasPago = this.state.formasPago;
        formValues.monedas = this.state.monedas;
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        formValues.establecimientos = this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = clientes;
        formValues.documentoCliente = clienteFiltered.length > 0 ? clienteFiltered[0].numeroDocumento : '';
        formValues.almacenes = almacenes ? almacenes : [];
        formValues.direcciones = direcciones ? direcciones : [];
        formValues.motivosNotaCredito = motivosNotaCredito ? motivosNotaCredito : [];
        formValues.unidadesMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;
        formValues.Tipoimpuesto = lst_tipo_impuesto;
        formValues.proyectos = this.state.proyectos;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        this.setState({ loadingEdit: false, visible: true, formValues });
    };

    handleImportar = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var idCliente = this.state.onGetFieldValue('idCliente');

            if (idCliente === undefined || idCliente.key === 0) {
                message.warning('Por favor busque y/o seleccione un cliente.');
                return;
            }

            var filter = {
                idCliente: idCliente.key,
                serie: '',
                documento: '',
            }

            var response = await comprobanteService.importarEmitidos(filter);

            this.setState({
                importarVisible: true,
                importarFormValues: {
                    dataSource: response
                }
            });
        });
    };

    handleSelectComprobante = async (row) => {

        var response = await comprobanteService.importarPorId(row.id);

        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }
        var listaComprobanteReferenciaValidate = this.state.formValues.listaComprobanteReferencia;

        if (listaComprobanteReferenciaValidate.length > 0) {
            var exist_referencia_count = listaComprobanteReferenciaValidate.filter(m => m.serie === row.serie && m.documento === row.documento).length;

            if (exist_referencia_count > 0) {
                message.warning('El comprobante ya ha sido importado.');
                return;
            }
        }

        const seriesUser = await usuarioService.listarSeriesPorIdUsuario(auth.user().id);
        var serieInicial = response.idTipoComprobante === FACTURA.ID ? "F" : "B";
        var filterSerie = seriesUser.find(m => m.idTipoComprobante === NOTA_DE_CREDITO.ID && m.serie.substring(0, 1) == serieInicial);
        var serieComprobante = filterSerie === undefined ? "" : filterSerie.serie;
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;
        var productos = [];
        var listaComprobanteDetalle = [];
        var listaComprobanteReferencia = [];
        var listaComprobanteCuotas = [];

        response.detalles.forEach(element => {
            const identifier = global.fetchUniqueCode();
            var itemsConversion = [];
            listaComprobanteDetalle.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                flagExonerado: element.flagExonerado,
                flagGratuito: element.flagGratuito,
                flagISC: element.flagISC,
                flagAplicarSerie: element.flagAplicarSerie,
                isc: element.importeISC,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                precioPromedio: element.precioPromedio,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                cantidad: element.cantidad,
                totalDetalle: element.totalDetalle.toFixed(2),
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: element.subTotal,
                igv: element.igv,
                total: element.total,
                flagConversion: element.flagConversion,
                itemConversion: itemsConversion,
                flagVencimiento: element.flagVencimiento,
                fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
                listaDetalleSerie: element.listaDetalleSerie,
                listaDetalleSerieAll: element.listaDetalleSerie,
                idImpuesto: element.idImpuesto,
                detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
            });

            productos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                cantidad: element.cantidad,
                idUnidadMedida: element.idUnidadMedida,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                precioPromedio: element.precioPromedio,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                porcentajeDescuento: 0,
                importeDescuento: 0,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagExonerado: element.flagExonerado,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                flagAplicarSerie: element.flagAplicarSerie,
                subTotal: element.subTotal,
                flagConversion: element.flagConversion,
                itemConversion: itemsConversion,
                flagVencimiento: element.flagVencimiento,
                fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
                listaDetalleSerie: element.listaDetalleSerie,
                listaDetalleSerieAll: element.listaDetalleSerie,
                idImpuesto: element.idImpuesto,
                detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
            });
        });

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idTipoComprobante: response.idTipoComprobante,
            serie: response.serie,
            documento: response.documento
        });

        response.cuotas.forEach(element => {
            listaComprobanteCuotas.push({
                identifier: global.fetchUniqueCode(),
                correlativo: element.correlativo,
                estado: element.estado,
                fechaVencimiento: element.fechaVencimientoStr,
                montoCuota: element.montoCuota,
            });

        });



        const almacenes = await almacenService.listarPorIdEstablecimiento(response.idEstablecimiento);
        const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.idEstablecimiento);
        this.setState({
            formValues: {
                ...this.state.formValues,
                almacenes: almacenes,
                listasPrecio: listasPrecio,
                idEstablecimiento: response.idEstablecimiento,
                idAlmacen: response.idAlmacen,
                idMoneda: response.idMoneda,
                idListaPrecio: response.idListaPrecio,
                serie: serieComprobante,
                idCaja: row.idCaja,
                idProyecto: response.idProyecto,
                idFormaPago: response.idFormaPago,
                listaComprobanteDetalle: listaComprobanteDetalle,
                listaComprobanteReferencia: listaComprobanteReferencia,
                listaComprobanteCuota: listaComprobanteCuotas,
                idDocumentoImportadoCredito: response.idTipoComprobante,
                otroImpuesto: response.tipoImpuesto,
                tipoCambio: response.tipoCambio,
                fechaVencimientoStr: global.fetchCurrentDateStr(),
                diasVencimiento: 0,
                idVendedor: response.idVendedor,
                flagExportacion: response.flagExportacion,

                sumaExonerada: response.totalDetalleExonerado ?? 0,
                sumaInafecta: response.totalDetalleInafecto ?? 0,
                sumaGratuita: response.totalDetalleGratuito ?? 0,


            },
            isCredito: listaComprobanteCuotas.length > 0 ? true : false,

        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({
                serie: serieComprobante,
                detalleProductos: detalleProductos,
                idVendedor: { key: response.idVendedor },
                idEstablecimiento: { key: response.idEstablecimiento },
                idAlmacen: { key: response.idAlmacen },
                idMoneda: { key: response.idMoneda },
                idProyecto: { key: response.idProyecto },
                idListaPrecio: { key: response.idListaPrecio },
                idTipoComprobanteImportado: response.idTipoComprobante,
                sumaTotalDetalle: response.totalDetalle,
                sumaImporteDescuento: 0,
                sumaSubTotal: response.subTotal,
                sumaIgv: response.igv,
                sumaIsc: response.flagDetraccion ? 0 : response.isc,
                sumaTotal: response.flagDetraccion ? response.totalDetraccion : response.total,

                sumaExonerada: response.totalDetalleExonerado ?? 0,
                sumaInafecta: response.totalDetalleInafecto ?? 0,
                sumaGratuita: response.totalDetalleGratuito ?? 0,
                tipoCambio: parseFloat(response.tipoCambio).toFixed(3),
                flagExportacion: response.flagExportacion

            });
        });
    };

    sumCollection = (collection, property) => {
        var suma = 0;
        collection.forEach(element => {
            suma = suma + element[property]
        });
        return suma;
    };

    fetchFieldValueSum = (property) => {
        var suma = 0;
        var obj = Object.assign({}, this.state.onGetFieldValue(property));

        for (var [, value] of Object.entries(obj)) {
            suma = suma + parseFloat(value);
        }

        return suma;
    };

    handleSave = async (item, form) => {

        this.setState({ saveLoading: true });
        var montoMaximoVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_VALIDAR_TOPE_MAXIMO_VENTAS_SOLES)[0].valor;
        if (item.total >= parseFloat(montoMaximoVenta)) {
            dialog.confirm("El total de la venta excede el monto máximo establecido " + global.decimalFormat(parseFloat(montoMaximoVenta).toFixed(2)) + " ¿Desea continuar?", async () => {
                this.handleSaveUpdate(item, form);
            }, async () => {
                this.setState({ saveLoading: false });
            });
        }
        else {
            this.handleSaveUpdate(item, form);
        }
    };

    handleSaveUpdate = async (item, form) => {
        var envioAutomatico = this.state.configuraciones.filter((m) => m.abreviatura === EMISION_AUTO).length >= 1 ? true : false;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (item.id === 0)
                response = await comprobanteService.registrar(item);
            else
                response = await comprobanteService.modificar(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false, saveLoading: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);

                if (envioAutomatico) {
                    setTimeout(() => {
                        this.setState({ loadingEmitir: true, loadingEdit: true });
                        this.handleEnvioComprobantes(item.id === 0 ? response.data : item.id);

                    }, 1000);
                }
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                this.setState({ saveLoading: false });
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
            this.setState({ saveLoading: false });
        }, async () => {
            this.setState({ saveLoading: false });
        });
    };
    handleEnvioComprobantes = async (data) => {

        var response = await comprobanteService.emitir({ id: data });
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
        }
        this._handlePagination(this.state.filter);
        this.setState({ loadingEmitir: false, loadingEdit: false });

    }
    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeForm = async (property, value, form) => {
        if (property === "fechaStr") {
            const fecha = moment(value, 'DD/MM/YYYY');
            const fechaVencimiento = moment(form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString()
            });
        }

        if (property === "idFormaPago") {

            var idDocumento = form.getFieldValue('idMotivoNotaCredito') == undefined ? 0 : form.getFieldValue('idMotivoNotaCredito').key;

            if (idDocumento == 11 && value === 1) {

                dialog.error('El motivo seleccionado solo puede afectar al documento de tipo credito.');
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idFormaPago: value,
                },
            });
            form.setFieldsValue({
                idFormaPago: value
            });
        }

        if (property === "idMoneda") {

            form.setFieldsValue({
                codigoMoneda: value == SOLES ? "PEN" : "USD",
            });
        }

        if (property === "idMotivoNotaCredito") {

            if (value == "11") {
                if (!this.state.isCredito) {
                    dialog.error('El motivo seleccionado solo puede afectar al documento de tipo credito.');
                    return false;
                } else {
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            idFormaPago: 2,
                        },
                    });

                    form.setFieldsValue({
                        idFormaPago: { key: 2 }
                    });
                }

            }
            if (value != "11") {

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idFormaPago: value,
                    },
                });

                form.setFieldsValue({
                    idFormaPago: { key: 1 }
                });

            }
        }
        if (property === "idCliente") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value.split("-")[0]);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoCliente: { key: direcciones.length > 0 ? direcciones[0].id : undefined },
                    direccionCliente: direcciones.length > 0 ? direcciones[0].direccion : ""
                });
            });
        }

        if (property === "idCultivo") {
            const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fenologicas: fenologicas ? fenologicas : [],
                }
            },
                () => {
                    form.setFieldsValue({
                        idFenologica: {
                            key: undefined,
                        },
                    });
                }
            );
        }

        if (property == "otroImpuesto") {
            var data = form.getFieldValue(property);

            if (this.state.formValues.listaComprobanteDetalle.length > 0) {

                dialog.confirm(
                    <span>
                        Al cambiar el tipo de impuesto se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: [],
                                listaComprobanteCuota: [],
                                listaComprobanteReferencia: [],
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            }
        }
        if (property === "flagContingencia") {
            if (value) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        flagContingencia: value,
                        flagDisableSerieDocumento: false,
                    }
                })
            } else {
                const datosIniciales = await comprobanteService.datosIniciales({ idUsuario: auth.user().id, idTipoComprobante: NOTA_DE_CREDITO.ID });
                const serie = [undefined, null].includes(datosIniciales?.serie) ? '' : datosIniciales.serie;
                var fechaActual = global.fetchCurrentDateStr();
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        flagDisableSerieDocumento: true,
                        fechaStr: fechaActual,
                        flagContingencia: value,
                        serie: serie,
                        documento: ''
                    }
                }, () => {
                    form.setFieldsValue({
                        fechaStr: moment(fechaActual, "DD/MM/YYYY")
                    });
                });
            }
        }
        if (property === "flagPermisoFC") {
            if (value) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        flagDisableFecha: false
                    }
                })
            } else {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        flagDisableFecha: auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false
                    }
                })
            }
        }
        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: []
                }
            })
        }

        if (
            property === "idEstablecimiento" ||
            property === "idListaPrecio" ||
            property === "idAlmacen"
        ) {
            var data = form.getFieldValue(property);
            var label =
                property === "idEstablecimiento"
                    ? "el establecimiento"
                    : property === "idListaPrecio"
                        ? "la lista de precio"
                        : "el almacén";
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(
                    <span>
                        Al cambiar {label} se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {
                        if (property === "idEstablecimiento") {
                            this.setState({
                                formValues: { ...this.state.formValues, almacenLoading: true },
                            });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(
                                value
                            );

                            const listasPrecio = this.state.listasPrecio.filter(
                                (m) => m.idEstablecimiento === value
                            );

                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenes ? almacenes : [],
                                    listasPrecio: listasPrecio ? listasPrecio : []
                                },
                            });
                            form.setFieldsValue({
                                idAlmacen: undefined,
                                idListaPrecio: undefined,
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            } else {
                if (property === "idEstablecimiento") {
                    this.setState({
                        formValues: { ...this.state.formValues, almacenLoading: true },
                    });
                    const almacenes = await almacenService.listarPorIdEstablecimiento(
                        value
                    );
                    const listasPrecio = this.state.listasPrecio.filter(
                        (m) => m.idEstablecimiento === value
                    );
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenes ? almacenes : [],
                            listasPrecio: listasPrecio ? listasPrecio : []
                        },
                    });
                    form.setFieldsValue({
                        idAlmacen: undefined,
                        idListaPrecio: undefined
                    });
                }
            }
        }
    };

    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        //const response = await padronReducidoService.ncnd(value); 

        var numberDocument = form.getFieldValue("documentoCliente");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }
        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerDniApi(value) :
            await padronReducidoService.obtenerRucApi(value);
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, clienteLoading: false } });

            return;
        }

        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: response.data.direcciones
                }
            }, () => {
                form.setFieldsValue({
                    clientes: response.data.clientes,
                    idCliente: response.data.clientes.length > 0 ? { key: response.data.clientes[0].id } : undefined,
                    idEstablecimientoCliente: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined,
                    direccionCliente: response.data.direcciones.length > 0 ? response.data.direcciones[0].direccion : ""
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    clientes: [],
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };

    handleBuscarProducto = async (value) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            codigoNombre: value
        }

        var response = await productoService.stock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleOpenSearchProductModal = async () => {
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idListaPrecio === undefined || idListaPrecio.key === 0) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key
        }

        var response = await productoService.stock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                precioUnitInclyIGV: response.precioUnitInclyIGV,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleSelectProduct = async (row) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var params = auth.user().parametros;

        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
        var producto_lote = params.filter((m) => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1";

        var itemsConversion = [];
        if (conversionMedida) {
            //itemsConversion = await productoService.listarConversionProductoPorId(row.id);
        }

        // ✅ VALIDACIÓN DINÁMICA
        const existe = listaComprobanteDetalle.some(det => {
            if (producto_lote) {
                // valida producto + lote
                return det.idProducto === row.id &&
                    det.numeroLote === row.numeroLote;
            }
            return false;
        });
        if (existe && producto_lote) {
            dialog.info("Este producto con el mismo lote ya fue agregado.");
            return;
        }
        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            idTipoProducto: row.idTipoProducto,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagISC: row.flagISC,
            flagAplicarSerie: row.flagAplicarSerie,
            isc: 0,
            precioUnitarioSinIGV: 0,
            porcentajeMargenComercial: row.porcentajeMargenComercial,
            precioPromedio: row.precioPromedio,
            precioUnitario: row.precioUnitario,
            cantidad: 0,
            totalDetalle: 0,
            porcentajeDescuento: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            numeroLote: row.numeroLote,
            idImpuesto: row.idImpuesto,
            stock: row.stock,
            itemConversion: itemsConversion ? itemsConversion : [],
            flagConversion: false,
            flagVencimiento: row.flagVencimiento,
            fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null,
            listaDetalleSerie: [],
            selectedSerie: []
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                idTipoProducto: item.idTipoProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitarioSinIGV: 0,
                porcentajeMargenComercial: item.porcentajeMargenComercial,
                precioPromedio: item.precioPromedio,
                precioUnitario: item.precioUnitario,
                porcentajeDescuento: item.porcentajeDescuento,
                importeDescuento: item.importeDescuento,
                total: item.total,
                flagAfecto: item.flagAfecto,
                flagISC: item.flagISC,
                flagOtrosImpuesto: false,
                flagGratuito: item.flagGratuito,
                flagChangeTotal: false,
                flagAplicarSerie: item.flagAplicarSerie,
                subTotal: 0,
                numeroLote: row.numeroLote,
                idImpuesto: row.idImpuesto,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagConversion: false,
                flagVencimiento: row.flagVencimiento,
                fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null,
                listaDetalleSerie: [],
                selectedSerie: []
            };

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
        });
    };



    handleRemoverProducto = (row, form) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`)
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach(item => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre
        });
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            serie: "",
            documento: "",
            flagInterno: false
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleReferencia = async (value, identifier) => {

        if ([BOLETA_DE_VENTA.ID, FACTURA.ID].includes(value)) {
            const seriesUser = await usuarioService.listarSeriesPorIdUsuario(auth.user().id);

            var serieInicial = value === FACTURA.ID ? "F" : "B";
            var filterSerie = seriesUser.find(m => m.idTipoComprobante === NOTA_DE_CREDITO.ID && m.serie.substring(0, 1) == serieInicial);
            var serieComprobante = filterSerie === undefined ? "" : filterSerie.serie;

            this.state.onSetFieldsValue({
                serie: serieComprobante,
            });

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    serie: serieComprobante,
                }
            });
        }
    };

    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "2") { // Referencias
            onSetFieldsValue({
                flagReferencia: true
            })
        }

        if (key == "3") { // Cuotas
            onSetFieldsValue({
                flagCuota: true
            })
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            const newLocal = "2";
            if (this.state.formValues.activeKey === newLocal)
                this.handleAddReferencia();

            const cuotas = "3";
            if (this.state.formValues.activeKey === cuotas)
                this.handleAddCuota();
        });
    };

    handleAddCuota = () => {
        var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota;

        if (this.state.formValues.idDocumentoImportadoCredito == 999999) {
            dialog.error('Ya no puedes agregar la cuota por que tiene documento origen');

        } else {

            listaComprobanteCuota.push({
                correlativo: this.state.formValues.listaComprobanteCuota.length + 1,
                identifier: global.fetchUniqueCode(),
                fechaVencimiento: global.fetchCurrentDateStr(),
                montoCuota: 0
            });
        }


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteCuota: listaComprobanteCuota
            }
        });
    };

    handleView = async (item) => {
        this.setState({ loadingVer: true });
        var response = await comprobanteService.ver({ id: item.id });
        if (response !== undefined) {
            response.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;

            this.setState({
                loadingVer: false,
                viewVisible: true,
                viewFormValues: response
            });
        }
    }

    handleOpenEmitirModal = async (item) => {
        debugger
        this.setState({ loadingEmitir: true });
        var visualizar = auth.user().parametros.filter(m => m.abreviatura === VENTA_VISUALIZACION_DOCUMENTOS)[0].valor === "1" ? true : false;
        if (visualizar) {
            var response = await comprobanteService.pdfA4({ id: item.id });
            var file = window.URL.createObjectURL(response.data);
            this.setState({
                loadingEmitir: false,
                emitirVisible: true,
                emitirFilePdf: file,
                selectedItem: item
            });
        } else {
            this.handleEmitir(item);
        }

    };

    handleEmitir = async (item) => {
        debugger
        item = this.state.emitirVisible ? this.state.selectedItem : item;
        var flagEmitir = this.state.configuraciones.filter((m) => m.abreviatura === EMISION_COMPRO).length >= 1 ? true : false;

        if (flagEmitir) {
            dialog.confirm("¿Desea enviar el comprobante a sunat " + item.serieDocumentoComprobante + " ?", async () => {
                var response = await comprobanteService.emitir({ id: item.id });
                this.setState({ loadingEmitir: false });

                if (response.status === 200) {
                    //form.resetFields();
                    dialog.success(response.data);
                    this._handlePagination(this.state.filter);
                    this.setState({ emitirVisible: false });
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                    return;
                }
                dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
            }, async () => { this.setState({ loadingEmitir: false }) });
            return;
        }
        this.setState({ loadingEmitir: false });

        message.warning('Usted no puede emitir comprobantes');

    };


    handleAnular = async (item) => {
        dialog.confirm(`¿Desea anular el comprobante ${item.serie}-${item.documento}?`, async () => {
            var response = await comprobanteService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(response.data);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleImprimir = async (item) => {
        this.setState({ loadingImprimir: true });
        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;
        var isEpson = JSON.parse(localStorage.getItem("isEpson"));

        if (idFormato === 1) {
            response = await comprobanteService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await comprobanteService.ticket({
                id: item.id,
                isEpson: isEpson == null ? false : isEpson
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await comprobanteService.ticket50({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            loadingImprimir: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idComprobante: item.id
            },
            selectedItem: item
        });
    };

    handleSwitch = async (e) => {
        localStorage.setItem("isEpson", JSON.stringify(e))
        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                isEpson: e,
            }
        })

        setTimeout(() => {
            this.handleChangeImprimir(2)
        }, 100);
    }

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await comprobanteService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await comprobanteService.ticket(
                {
                    id: this.state.imprimirFormValues.idComprobante,
                    isEpson: JSON.parse(localStorage.getItem("isEpson")),
                });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await comprobanteService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            }
        });
    };

    handleCorreo = async (item) => {
        this.setState({ loadingCorreo: true });
        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;

        /*         if (idFormato === 1) {
                    response = await comprobanteService.pdfA4({ id: item.id });
                    file = window.URL.createObjectURL(response.data);
                }
        
                if (idFormato === 2) {
                    response = await comprobanteService.ticket({ id: item.id });
                    file = window.URL.createObjectURL(response.data);
                }
        
                if (idFormato === 3) {
                    response = await comprobanteService.ticket50({ id: item.id });
                    file = window.URL.createObjectURL(response.data);
                }
         */
        this.setState({
            loadingCorreo: false,
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                file,
                idComprobante: item.id,
                idFormato: 1,
                correoCliente: item.correoCliente
            }
        });
    };

    handleChangeCorreo = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await comprobanteService.pdfA4({ id: this.state.correoFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await comprobanteService.ticket({ id: this.state.correoFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await comprobanteService.ticket50({ id: this.state.correoFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            correoFormValues: {
                ...this.state.correoFormValues,
                idFormato,
                file
            }
        });
    };

    handleEnviarCorreo = async (data, form) => {
        dialog.confirm('¿Desea enviar el correo?', async () => {
            var response = await comprobanteService.enviarCorreo(data);

            if (response.status === 200) {
                form.resetFields();
                dialog.success('El correo ha sido enviado.');
                this.setState({ correoVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleOpenCdrModal = async (row) => {
        this.setState({
            cdrVisible: true,
            selectedItem: row
        });
    };

    handleDownloadXml = async () => {
        var response = await comprobanteService.xml({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreXML);
    };

    handleDownloadCdr = async () => {
        var response = await comprobanteService.cdr({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);
    };

    handleDownloadPdf = async () => {
        /*         
                var response = undefined;
                var file = undefined;
        
                if (this.state.imprimirFormValues.idFormato === 1) {
                    response = await comprobanteService.pdfA4({ id: this.state.selectedItem.id });
                    file = window.URL.createObjectURL(response.data);
                }
        
                if (this.state.imprimirFormValues.idFormato === 2) {
                    response = await comprobanteService.ticket({ id: this.state.selectedItem.id });
                    file = window.URL.createObjectURL(response.data);
                }
        
                if (this.state.imprimirFormValues.idFormato === 3) {
                    response = await comprobanteService.ticket50({ id: this.state.selectedItem.id });
                    file = window.URL.createObjectURL(response.data);
                }
        
                if (response !== undefined)
                    global.dowloadFile(response.data, this.state.selectedItem.serieDocumentoComprobante + ".pdf"); */
        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.selectedItem.serieDocumentoComprobante + ".pdf");

    };


    handleRemoverCuota = (item) => {
        if (this.state.idDocumentoImportadoCredito == 9999) {
            dialog.error('Ya no puedes eliminar la cuota porque tiene documento origen');
        } else {
            // Filtra la cuota a eliminar
            let listaComprobanteCuota = this.state.formValues.listaComprobanteCuota.filter(m => m.identifier !== item.identifier);

            // Si la cuota eliminada estaba en medio de la lista, reordena las cuotas
            listaComprobanteCuota = listaComprobanteCuota.map((cuota, index) => ({
                ...cuota,
                correlativo: index + 1 // Asume que 'orden' es el campo para la posición de la cuota
            }));

            // Actualiza el estado con la lista reordenada
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteCuota: listaComprobanteCuota
                }
            });
        }
    };

    handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle, index) => {
        debugger;
        this.setState({
            setFieldsValueDetalle,
            getFieldValueDetalle
        }, async () => {
            debugger;
            this.setState({
                agregarSerieVisible: true,
                agregarSerieModal: {
                    ...this.state.agregarSerieModal,
                    idProducto: row.idProducto,
                    codigoProducto: row.codigo,
                    nombreProducto: row.nombre,
                    serie: '',
                    listaDetalleSerie: row.listaDetalleSerieAll,
                    onCalculateDetail: onCalculateDetail,
                    setFieldsValueDetalle: setFieldsValueDetalle,
                    getFieldValueDetalle: getFieldValueDetalle,
                    selectedRowKeys: row.selectedSerie,
                    index: index,
                    idTipoComprobante: NOTA_DE_CREDITO.ID
                }
            });

        });
    }

    handleChangeSelectedSerie = (selected, rows, onCalculateDetail, idProductoRemoveSerie, index) => {
        debugger;
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if (selected.length > 0) {
            listaComprobanteDetalle.forEach(detalle => {
                debugger;
                if (detalle.idProducto === rows[0].idProducto) {
                    detalle.selectedSerie = selected;
                    detalle.listaDetalleSerie = rows;
                    detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
                }
            });
        } else {
            listaComprobanteDetalle.forEach(detalle => {
                debugger;
                if (detalle.idProducto === idProductoRemoveSerie) {
                    detalle.selectedSerie = [];
                    detalle.listaDetalleSerie = [];
                    detalle.detalleSeries = '';
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
                }
            });
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                detalleProductos: listaComprobanteDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                selectedRowKeys: selected
            }
        });
    };

    searchTimeout = null;
    handleSearchClientes = (value, form) => {

        // Limpiar timeout anterior
        clearTimeout(this.searchTimeout);

        // No buscar si está vacío o tiene menos de 3 caracteres
        if (!value || value.trim().length < 3) {
            return;
        }

        this.searchTimeout = setTimeout(async () => {
            this.setState({ fetching: true });

            try {
                const response = await clienteService.getByComprobante({
                    id: 0,
                    value: value,
                    type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
                });


                if (response) {
                    form.setFieldsValue({
                        clientes: response,
                    });
                }
            } finally {
                this.setState({ fetching: false });
            }
        }, 500); // Espera 500 ms después de la última tecla
    };

    async componentDidMount() {
        this._isMounted = true;
        // const datosIniciales = await this.obtenerDatosIniciales();
        var idUsuario = auth.user().id;
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });

        // const serie = [undefined, null].includes(datosIniciales?.serie) ? '' : datosIniciales.serie;
        this.setState({ filter: { ...this.state.filter } });

        this._initPagination({ ...this.state.filter }, comprobanteService.paginacion);
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const proyectos = await proyectoService.listar();
        const motivosNotaCredito = await motivoNotaCreditoService.listar()

        /*         const monedas = await monedaService.listar();
                const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
                const listasPrecio = await listaPrecioService.listar();
                const establecimientos = await establecimientoService.principales();
                const vendedores = await vendedorService.listar();
                const tiposComprobante = await tipoComprobanteService.listar();
                const detracciones = await detraccionService.listar();
                const clientes = await clienteService.listar();
                const formasPago = await formaPagoService.listar(); */


        const response = await notasService.listar();

        const monedas = response.list_Moneda.result;
        const listasPrecio = response.list_Precio.result;
        const establecimientos = response.list_Establecimiento.result;
        const vendedores = response.list_Vendedor.result;
        const tiposComprobante = [];// response.list_TipoComprobante.result;
        const detracciones = [];// response.list_Detraccion.result;
        const clientes = [];// response.list_Cliente.result;
        const formasPago = response.list_FormaPago.result;
        const estado = await comprobanteService.listarEstado();
        const unidadesMedida = [];// response.list_UnidadMedida.result;
        const totaldocument = response.list_TotalComprobante.result;
        const cultivos = response.list_Cultivo.result;
        const company = response.list_Empresa;


        // var formasPago_filter = formasPago.fkilter(m=> m.id === CREDITO);
        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                monedas: monedas ? monedas : [],
                listasPrecio: listasPrecio ? listasPrecio : [],
                establecimientos: establecimientos ? establecimientos : [],
                vendedores: vendedores ? vendedores : [],
                tiposComprobante: tiposComprobante ? tiposComprobante : [],
                detracciones: detracciones ? detracciones : [],
                clientes: clientes ? clientes : [],
                formasPago: formasPago ? formasPago : [],
                estado: estado ? estado : [],
                unidadesMedida: unidadesMedida ? unidadesMedida : [],
                proyectos: proyectos ? proyectos : [],
                motivosNotaCredito: motivosNotaCredito ? motivosNotaCredito : [],
                configuraciones: configuraciones ? configuraciones : [],
                totaldocument: totaldocument ? totaldocument : [],
                cultivos: cultivos ? cultivos : [],
                company: company

            });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    };

    render() {
        return (
            <div>
                <Header
                    title="Nota de Crédito"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource || this.state.loadingNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    estado={this.state.estado}
                    nota={true}
                    proyectos={this.state.proyectos}
                    vendedores={this.state.vendedores}
                    motivos={this.state.motivosNotaCredito}
                    configuraciones={this.state.configuraciones}

                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit || this.state.loadingSource}
                    loadingVer={this.state.loadingVer}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingImprimir={this.state.loadingImprimir || this.state.loadingSource}
                    loadingEmitir={this.state.loadingEmitir || this.state.loadingSource}
                    loadingCorreo={this.state.loadingCorreo}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onChange={this._handleChangePagination}
                    onView={this.handleView}
                    onEmitir={this.handleOpenEmitirModal}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                    onCorreo={this.handleCorreo}
                    onCdr={this.handleOpenCdrModal}
                    onTipoFilter={2}
                />
                <FormModal
                    visible={this.state.visible}
                    saveLoading={this.state.saveLoading}
                    formValues={this.state.formValues}
                    onBuscarCliente={this.handleBuscarCliente}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onAgregarSerie={this.handleAgregarSerie}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onRemoverCuota={this.handleRemoverCuota}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onImportar={this.handleImportar}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    configuraciones={this.state.configuraciones}
                    CalculateDescuento={this.calculateDescuento}
                    handleReferencia={this.handleReferencia}
                    fetchClientes={this.handleSearchClientes}
                    fetching={this.state.fetching}
                />
                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    precioUnitInclyIGV={this.state.searchProductFormValues.precioUnitInclyIGV}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />
                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />
                <EmitirModal
                    visible={this.state.emitirVisible}
                    file={this.state.emitirFilePdf}
                    onEmitir={this.handleEmitir}
                    onClose={() => this.setState({ emitirVisible: false })}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onSwitch={this.handleSwitch}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <CorreoModal
                    visible={this.state.correoVisible}
                    formValues={this.state.correoFormValues}
                    onChange={this.handleChangeCorreo}
                    onClose={() => this.setState({ correoVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />
                <CdrModal
                    visible={this.state.cdrVisible}
                    item={this.state.selectedItem}
                    onDownloadXml={this.handleDownloadXml}
                    onDownloadCdr={this.handleDownloadCdr}
                    onGetCdr={this.handleDownloadCdr}

                    onClose={() => this.setState({ cdrVisible: false })}
                />
                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />
                <ImportarModal
                    tittle="Búsqueda de Comprobante"
                    visible={this.state.importarVisible}
                    dataSource={this.state.importarFormValues.dataSource}
                    onSelect={this.handleSelectComprobante}
                    onClose={() => this.setState({ importarVisible: false })}
                />

                <AgregarSerieModal
                    visible={this.state.agregarSerieVisible}
                    formValues={this.state.agregarSerieModal}
                    onCancel={() => this.setState({ agregarSerieVisible: false })}
                    onAgregarSerieDetalle={this.handleChangeSelectedSerie}
                    onRemove={this.handleRemoverSerieDetalle}
                />
            </div>
        );
    };
}